export default __webpack_public_path__ + "static/media/244-qatar.52fe1293.svg";